const http = require('../lib/httpClient');
const { getChannelId, getCookie, getEcommId } = require('../lib/browserData');
const { COOKIES } = require('../constants');

const SessionNotFoundError = {
  code: 'GET_USER_ERROR_SESSION_NOT_FOUND',
  message: 'Session not found',
};
const GetUserError = {
  code: 'GET_USER_ERROR',
  message: 'Failed to get user',
};

const endpoint = '/s/account/v2/profile';

async function catalystGetUser(tenantId, catalystBaseUrl = '') {
  const sessionId = getCookie(COOKIES.SESSION.VALUE);

  if (!sessionId) {
    return { data: undefined, errors: [SessionNotFoundError] };
  }

  const result = await http.get(`${catalystBaseUrl}${endpoint}`, {
    headers: {
      Authorization: sessionId,
      'x-channel-id': getChannelId(),
      'x-ecomm-name': getEcommId(tenantId),
    },
  });

  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [GetUserError] };

  const { _errors, ...data } = responseBody;

  return { data, errors: [] };
}

module.exports = catalystGetUser;
